// removed by extract-text-webpack-plugin
module.exports = {"menuCustom":"_3BI0iUKctpjty_ebRDpH3m","show":"_9Z22b4IoiqslwclvJ6PDq","moveUp":"zb645z_6CKa40h6DvZOxn","overlay":"pQcqVTircKw4m5XEaezqL","overlayshow":"_2_8Zmmy7Kcy5EFvxaUbDEM","hide":"_2RJ0aVIzxSuovlCxEzUuwQ","moveBottom":"_2OpP2x9npjWb5g1PTrqkvC","content":"_26QdTICSW1FbBKgJWX2REs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/SlideCustom.scss
// module id = 1124
// module chunks = 0